import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Suppliers() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ code: "", name: "", phone: "", address: "" });

  const load = useCallback(async () => setRows((await api.get("/suppliers")).data), []);
  useEffect(() => { load(); }, [load]);

  const openEdit = (r) => { setEditing(r); setForm({ ...r }); setOpen(true); };

  const save = async () => {
    try {
      if (editing) await api.put(`/suppliers/${editing.supplier_id}`, form);
      else await api.post("/suppliers", form);
      toast.success("Tersimpan"); setOpen(false); setEditing(null); load(); setForm({ code: "", name: "", phone: "", address: "" });
    }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };

  const remove = async (r) => {
    if (!window.confirm(`Hapus supplier ${r.name}?`)) return;
    try { await api.delete(`/suppliers/${r.supplier_id}`); toast.success("Supplier dihapus"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal menghapus"); }
  };

  return (
    <div data-testid="page-suppliers" className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-500 mb-2">Master Data</div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Supplier</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-slate-900 hover:bg-slate-800" data-testid="btn-new-supplier" onClick={() => setEditing(null)}><Plus className="h-4 w-4 mr-1" />Tambah Supplier</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editing ? "Ubah Supplier" : "Tambah Supplier"}</DialogTitle></DialogHeader>
            <div className="grid gap-3">
              <div><Label>Kode</Label><Input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} disabled={!!editing} /></div>
              <div><Label>Nama</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div><Label>No. HP</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              <div><Label>Alamat</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
            </div>
            <DialogFooter><Button onClick={save} className="bg-slate-900 hover:bg-slate-800" data-testid="btn-save-supplier">Simpan</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <Card>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs font-mono uppercase tracking-wider text-slate-500 text-left"><tr><th className="py-2 px-4">Kode</th><th>Nama</th><th>Telp</th><th>Alamat</th><th></th></tr></thead>
          <tbody>
            {rows.map(r => <tr key={r.supplier_id} className="border-b"><td className="py-2 px-4 font-mono text-xs">{r.code}</td><td>{r.name}</td><td>{r.phone}</td><td className="text-slate-500">{r.address}</td>
              <td className="whitespace-nowrap"><Button variant="ghost" size="sm" onClick={() => openEdit(r)} data-testid={`edit-supplier-${r.code}`}><Pencil className="h-3.5 w-3.5" /></Button><Button variant="ghost" size="sm" onClick={() => remove(r)} data-testid={`delete-supplier-${r.code}`}><Trash2 className="h-3.5 w-3.5 text-rose-600" /></Button></td>
            </tr>)}
            {rows.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-slate-400">Belum ada supplier</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
